
import React from 'react';
import { accountGroups } from '../data/chartData';
import { AccountGroupSection } from './AccountGroupSection';

export const AccountDetails = () => {
  return (
    <div className="space-y-4">
      {accountGroups.map((group) => (
        <AccountGroupSection key={group.name} group={group} />
      ))}
    </div>
  );
};
